import type * as Types from '../../../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { WbmFieldsFragmentDoc } from '../../../../../graphql/gql-fragments/warrant-board-member.graphql';
import { WpFieldsFragmentDoc, WpValidatorErrorFieldsFragmentDoc, EoValidatorErrorFieldsFragmentDoc, WiseErrorFieldsFragmentDoc, WpUpdateFieldsFragmentDoc } from '../../../../../graphql/gql-fragments/warrant-program.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlCreateWarrantBoardMemberMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlWpbmCreateInput;
}>;


export type GqlCreateWarrantBoardMemberMutation = { createWarrantBoardMember: { id: string, warrantProgramId: string, identityId: string, createdAt: string, updatedAt: string } };

export type GqlDeleteWarrantBoardMemberMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlDeleteWarrantBoardMemberMutation = { deleteWarrantBoardMember: { id: string } };

export type GqlWpSetBoardsStatementMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlWpSetBoardsStatementInput;
}>;


export type GqlWpSetBoardsStatementMutation = { wpSetBoardsStatement: { warrantProgram: { requiresShareLimitChange: boolean, boardsStatementDate?: string | null, boardsStatementEn?: string | null, boardsStatementOption?: Types.GqlBoardsStatementOption | null, boardsStatementSv?: string | null, companyId: string, currency: Types.GqlCurrency, valuationCompanyValue?: string | null, valuationDate?: string | null, createdAt: string, description: string, discountPricePerWarrant?: string | null, ibanAddress?: string | null, ibanBank?: string | null, ibanBic?: string | null, ibanNumber?: string | null, id: string, illiquidityDiscount?: string | null, maxNumberOfOptions?: string | null, name?: string | null, nonCashStatementPl?: string | null, nonCashStatementSl?: string | null, valuationNumberOfShares?: string | null, paidForAt?: string | null, payBeforeDate?: string | null, paymentAccountKind: Types.GqlPaymentAccountKind, paymentAccountNumber?: string | null, paymentKindCash: boolean, paymentKindNonCash: boolean, paymentKindOffset: boolean, paymentName?: string | null, pricePerWarrant?: string | null, primaryLang: boolean, riskfreeInterestRate?: string | null, secondaryLang: boolean, serviceKind?: number | null, shareSubscribeEndDate?: string | null, shareSubscribeStartDate?: string | null, shareholdersAgreementKind?: number | null, signatoryId?: string | null, snrAuthorizationId?: string | null, snrBondId?: string | null, snrCaseId?: string | null, strikePrice?: string | null, strikePriceFromQuotaValue?: boolean | null, stripeInvoiceId?: string | null, updatedAt: string, useRiksbankenRate?: boolean | null, usesStepper: boolean, valuationMethod?: Types.GqlValuationMethod | null, valuationSccId?: string | null, valuationShareIssueId?: string | null, volatility?: string | null, volatilityDate?: string | null, volatilityDocument?: string | null, warrantEndDate?: string | null, warrantKind: Types.GqlWarrantProgramKind, warrantStartDate?: string | null, warrantSubscribeEndDate?: string | null, wiseFullyDiluted?: boolean | null, wiseDepBondsRecordDay?: string | null, wiseCeil?: string | null, wiseFloor?: string | null, warrantsForQeso: boolean, antlerWise: boolean, minRoundSizeAmount?: string | null, useNetStrike: boolean, forEmployees: boolean, forBoardMembers: boolean, forAdvisors?: boolean | null, forInvestors: boolean, subscriberAccess: boolean, riksbankenRates?: Array<{ date: string, value: number }> | null, shareClasses: Array<{ name: string, voteWeight: string, quantity?: string | null, min: string, max: string }> } } };


export const CreateWarrantBoardMemberDocument = gql`
    mutation CreateWarrantBoardMember($companyId: ID!, $input: WpbmCreateInput!) {
  createWarrantBoardMember(companyId: $companyId, input: $input) {
    ...WbmFields
  }
}
    ${WbmFieldsFragmentDoc}`;
export type GqlCreateWarrantBoardMemberMutationFn = Apollo.MutationFunction<GqlCreateWarrantBoardMemberMutation, GqlCreateWarrantBoardMemberMutationVariables>;

/**
 * __useCreateWarrantBoardMemberMutation__
 *
 * To run a mutation, you first call `useCreateWarrantBoardMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWarrantBoardMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWarrantBoardMemberMutation, { data, loading, error }] = useCreateWarrantBoardMemberMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWarrantBoardMemberMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateWarrantBoardMemberMutation, GqlCreateWarrantBoardMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateWarrantBoardMemberMutation, GqlCreateWarrantBoardMemberMutationVariables>(CreateWarrantBoardMemberDocument, options);
      }
export type CreateWarrantBoardMemberMutationHookResult = ReturnType<typeof useCreateWarrantBoardMemberMutation>;
export type CreateWarrantBoardMemberMutationResult = Apollo.MutationResult<GqlCreateWarrantBoardMemberMutation>;
export type CreateWarrantBoardMemberMutationOptions = Apollo.BaseMutationOptions<GqlCreateWarrantBoardMemberMutation, GqlCreateWarrantBoardMemberMutationVariables>;
export const DeleteWarrantBoardMemberDocument = gql`
    mutation DeleteWarrantBoardMember($companyId: ID!, $id: ID!) {
  deleteWarrantBoardMember(companyId: $companyId, id: $id) {
    id
  }
}
    `;
export type GqlDeleteWarrantBoardMemberMutationFn = Apollo.MutationFunction<GqlDeleteWarrantBoardMemberMutation, GqlDeleteWarrantBoardMemberMutationVariables>;

/**
 * __useDeleteWarrantBoardMemberMutation__
 *
 * To run a mutation, you first call `useDeleteWarrantBoardMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWarrantBoardMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWarrantBoardMemberMutation, { data, loading, error }] = useDeleteWarrantBoardMemberMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWarrantBoardMemberMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteWarrantBoardMemberMutation, GqlDeleteWarrantBoardMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteWarrantBoardMemberMutation, GqlDeleteWarrantBoardMemberMutationVariables>(DeleteWarrantBoardMemberDocument, options);
      }
export type DeleteWarrantBoardMemberMutationHookResult = ReturnType<typeof useDeleteWarrantBoardMemberMutation>;
export type DeleteWarrantBoardMemberMutationResult = Apollo.MutationResult<GqlDeleteWarrantBoardMemberMutation>;
export type DeleteWarrantBoardMemberMutationOptions = Apollo.BaseMutationOptions<GqlDeleteWarrantBoardMemberMutation, GqlDeleteWarrantBoardMemberMutationVariables>;
export const WpSetBoardsStatementDocument = gql`
    mutation WpSetBoardsStatement($companyId: ID!, $input: WpSetBoardsStatementInput!) {
  wpSetBoardsStatement(companyId: $companyId, input: $input) {
    warrantProgram {
      ...WpFields
    }
  }
}
    ${WpFieldsFragmentDoc}`;
export type GqlWpSetBoardsStatementMutationFn = Apollo.MutationFunction<GqlWpSetBoardsStatementMutation, GqlWpSetBoardsStatementMutationVariables>;

/**
 * __useWpSetBoardsStatementMutation__
 *
 * To run a mutation, you first call `useWpSetBoardsStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWpSetBoardsStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wpSetBoardsStatementMutation, { data, loading, error }] = useWpSetBoardsStatementMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWpSetBoardsStatementMutation(baseOptions?: Apollo.MutationHookOptions<GqlWpSetBoardsStatementMutation, GqlWpSetBoardsStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlWpSetBoardsStatementMutation, GqlWpSetBoardsStatementMutationVariables>(WpSetBoardsStatementDocument, options);
      }
export type WpSetBoardsStatementMutationHookResult = ReturnType<typeof useWpSetBoardsStatementMutation>;
export type WpSetBoardsStatementMutationResult = Apollo.MutationResult<GqlWpSetBoardsStatementMutation>;
export type WpSetBoardsStatementMutationOptions = Apollo.BaseMutationOptions<GqlWpSetBoardsStatementMutation, GqlWpSetBoardsStatementMutationVariables>;